import { createRouter, createWebHistory } from 'vue-router';
import { onRouteError } from '~/common/middleware/routes.middleware';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [{
    path: '/:id',
    name: 'home',
    component: () => import('./App.widget-mapsnapshot.vue'),
  }],
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

router.onError(onRouteError);

export default router;
